import { variable } from '@angular/compiler/src/output/output_ast';
import { UnitSelectComponent } from 'ng-units';
import { Quantity } from 'pumpcalc-core';

export const Quantities = {
    systemDownstreamPressure: Quantity.PRESSURE,
    systemDownstreamSpeed: Quantity.SPEED,
    systemUpstreamPressure: Quantity.PRESSURE,
    systemUpstreamSpeed: Quantity.SPEED,
    xdim1:Quantity.XDIM,
    xdim2:Quantity.XDIM,
    length:Quantity.LENGTH,
    diameter:Quantity.XDIM,
    gasEntryTemperature:Quantity.TEMPERATURE,
    insideDiameter:Quantity.XDIM,
    radialGap:Quantity.XDIM,
    width:Quantity.XDIM,
    height:Quantity.XDIM,
    pressureUp:Quantity.PRESSURE,
    pressureDown:Quantity.PRESSURE,
    speedDown:Quantity.SPEED,
    throughPut:Quantity.THROUGHPUT,
    speedUp:Quantity.SPEED,
    crossSectionDimension1:Quantity.XDIM,
    crossSectionDimension2:Quantity.XDIM,
    downstreamPressure:Quantity.PRESSURE,
    downstreamSpeed: Quantity.SPEED,
    upstreamPressure: Quantity.PRESSURE,
    upstreamSpeed: Quantity.PRESSURE,
    systemThroughput: Quantity.THROUGHPUT,
    systemThroughputMassFlow : Quantity.THROUGHPUT_MASS_FLOW,
    systemThroughputMolarFlow : Quantity.THROUGHPUT_MOLAR_FLOW
}


export const Labels = {
    calculationFailed:"Calculation Failed",
    calculationMessage:"Calculation Message",
    systemThroughput: "System Throughput",
    systemConductance: "System Conductance",
    systemDownstreamPressure: "System Downstream Pressure",
    systemDownstreamSpeed: "System Downstream Speed",
    systemUpstreamPressure: "System Upstream Pressure",
    systemUpstreamSpeed: "System Upstream Speed",
    gasName:"Gas",
    gasRMM:"Gas RMM",
    gasGamma:"Gas Gamma",
    gasViscocity:"Gas Viscocity.",
    gasEntryTemperature:"Gas Temperature",
    crossSection:"Cross-Section",
    diameter:"Diameter",
    insideDiameter:"Inside Diameter",
    radialGap:"Radial Gap",
    width:"Width",
    height:"Height",
    length:"Length",
    bends:"Bends",
    numberInParallel:"Number in Parallel",
    parallel:"Parallel",
    pressureUp:"Pressure Up",
    pressureDown:"Pressure Down",
    speedDown:"Speed Down",
    throughPut:"Throughput",
    speedUp:"S Up",
    Cond:"Cond",
    flowType:"Flow Type",
    choking:"Choking",
    deltaP:"ΔP",
    k:"K",
    chokedK:"Choked K",
    molecularTP:"Molecular T.P.",
    knudsenNo:"Knudsen No.",
    reynoldsNo:"Reynolds No.",
    darcyF:"Darcy f",
    exitMachNo:"Exit Mach No.",
    exitVelocity:"Exit Vel",
    exitPressure:"Exit P",
    gasSection:"Gas",
    pipeWorkSection:"Pipework",
    boundaryConditionsSection:"Boundary Conditions",
    circular:"Circular",
    annular:"Annular",
    rectangular:"Rectangular",
    inletDiameter:"Inlet Diameter",
    crossSectionDimension1: "Cross Section Dimension 1",
    crossSectionDimension2: "Cross Section Dimension 2",
    molecularTransmissionProbability: "Molecular Transmission Probability",
    chokedPresureRatio: "Choked Pressure Ratio",
    conductance: "Conductance",
    darcyFrictionFactor: "Darcy Friction Factor",
    downstreamPressure: "Downstream Pressure",
    downstreamSpeed: "Downstream Speed",
    exitMachNumber: "Exit Mach Number",
    knudsenNumber: "Knudsen Number",
    pressureDifference: "Pressure Difference",
    pressureRatio: "Pressure Ratio",
    regime: "Regime",
    reynoldsNumber: "Reynolds Number",
    throughput: "Throughput",
    upstreamPressure: "Upstream Pressure",
    upstreamSpeed: "Upstream Speed",
    index:"",
    rangeOnVariableSection:"Range On Variable",
    xdim1:"xDim1",
    xdim2:"xDim2",
    min:"Min",
    max:"Max",
    variable:"Variable",
    intervals:"Intervals",
    systemThroughputMassFlow : "System Throughput Mass Flow",
    systemThroughputMolarFlow :"System Throughput Molar Flow"
};

export const Keys = {
    calculationFailed:"calculationFailed",
    calculationMessage:"calculationMessage",
    systemThroughput: "systemThroughput",
    systemConductance: "systemConductance",
    systemDownstreamPressure: "systemDownstreamPressure",
    systemDownstreamSpeed: "systemDownstreamSpeed",
    systemUpstreamPressure: "systemUpstreamPressure",
    systemUpstreamSpeed: "systemUpstreamSpeed",
    gasName:"gasName",
    gasRMM:"gasRMM",
    gasGamma:"gasGamma",
    gasViscocity:"gasViscocity",
    gasEntryTemperature:"gasEntryTemperature",
    crossSection:"crossSection",
    diameter:"diameter",
    insideDiameter:"insideDiameter",
    radialGap:"radialGap",
    width:"width",
    height:"height",
    length:"length",
    bends:"bends",
    numberInParallel:"numberInParallel",
    parallel:"parallel",
    pressureUp:"pressureUp",
    pressureDown:"pressureDown",
    speedDown:"speedDown",
    throughPut:"throughPut",
    speedUp:"speedUp",
    Cond:"Cond",
    flowType:"flowType",
    choking:"choking",
    deltaP:"deltaP",
    k:"k",
    chokedK:"chokedK",
    molecularTP:"molecularTP",
    knudsenNo:"knudsenNo",
    reynoldsNo:"reynoldsNo",
    darcyF:"darcyF",
    exitMachNo:"exitMachNo",
    exitVelocity:"exitVelocity",
    exitPressure:"exitPressure",
    gasSection:"gasSection",
    pipeWorkSection:"pipeWorkSection",
    pipeWorkErrors:"pipeWorkErrors",
    boundaryConditionsSection:"boundaryConditionsSection",
    circular:"circular",
    annular:"annular",
    rectangular:"rectangular",
    inletDiameter:"inletDiameter",
    crossSectionDimension1: "crossSectionDimension1",
    crossSectionDimension2: "crossSectionDimension2",
    molecularTransmissionProbability: "molecularTransmissionProbability",
    chokedPresureRatio: "chokedPresureRatio",
    conductance: "conductance",
    darcyFrictionFactor: "darcyFrictionFactor",
    downstreamPressure: "downstreamPressure",
    downstreamSpeed: "downstreamSpeed",
    exitMachNumber: "exitMachNumber",
    knudsenNumber: "knudsenNumber",
    pressureDifference: "pressureDifference",
    pressureRatio: "pressureRatio",
    regime: "regime",
    reynoldsNumber: "reynoldsNumber",
    throughput: "throughput",
    upstreamPressure: "upstreamPressure",
    upstreamSpeed: "upstreamSpeed",
    index:"index",
    rangeOnVariableSection:"rangeOnVariableSection",
    xdim1:"xdim1",
    xdim2:"xdim2",
    min:"min",
    max:"max",
    variable:"variable",
    intervals:"intervals",
    systemThroughputMassFlow:"systemThroughputMassFlow",
    systemThroughputMolarFlow:"systemThroughputMolarFlow"
};

export const LabelToKeys = {
    "System Throughput":"systemThroughput",
    "System Conductance":"systemConductance",
    "System Downstream Pressure":"systemDownstreamPressure",
    "System Downstream Speed":"systemDownstreamSpeed",
    "System Upstream Pressure":"systemUpstreamPressure",
    "System Upstream Speed":"systemUpstreamSpeed",
    "Gas":"gasName",
    "Gas RMM":"gasRMM",
    "Gas Gamma":"gasGamma",
    "Gas Viscocity.":"gasViscocity",
    "Gas Temperature":"gasEntryTemperature",
    "Cross-Section":"crossSection",
    "Diameter":"diameter",
    "Inside Diameter":"insideDiameter",
    "Radial Gap":"radialGap",
    "Width":"width",
    "Height":"height",
    "Length":"length",
    "Bends":"bends",
    "Number in Parallel":"numberInParallel",
    "Parallel":"parallel",
    "Pressure Up":"pressureUp",
    "Pressure Down":"pressureDown",
    "Speed Down":"speedDown",
    "Throughput":"throughPut",
    "S Up":"speedUp",
    "Cond":"Cond",
    "Flow Type":"flowType",
    "Choking":"choking",
    "ΔP":"deltaP",
    "K":"k",
    "Choked K":"chokedK",
    "Molecular T.P.":"molecularTP",
    "Knudsen No.":"knudsenNo",
    "Reynolds No.":"reynoldsNo",
    "Darcy f":"darcyF",
    "Exit Mach No.":"exitMachNo",
    "Exit Vel":"exitVelocity",
    "Exit P":"exitPressure",
    "Pipework":"pipeWorkSection",
    "Boundary Conditions":"boundaryConditionsSection",
    "Circular":"circular",
    "Annular":"annular",
    "Rectangular":"rectangular",
    "Inlet Diameter":"inletDiameter",
    "Cross Section Dimension 1":"crossSectionDimension1",
    "Cross Section Dimension 2":"crossSectionDimension2",
    "Molecular Transmission Probability":"molecularTransmissionProbability",
    "Choked Pressure Ratio":"chokedPresureRatio",
    "Conductance":"conductance",
    "Darcy Friction Factor":"darcyFrictionFactor",
    "Downstream Pressure":"downstreamPressure",
    "Downstream Speed":"downstreamSpeed",
    "Exit Mach Number":"exitMachNumber",
    "Knudsen Number":"knudsenNumber",
    "Pressure Difference":"pressureDifference",
    "Pressure Ratio":"pressureRatio",
    "Regime":"regime",
    "Reynolds Number":"reynoldsNumber",
    "Upstream Pressure":"upstreamPressure",
    "Upstream Speed":"upstreamSpeed",
    "":"index",
    "Range On Variable":"rangeOnVariableSection",
    "xDim1":"xdim1",
    "xDim2":"xdim2",
    "Min":"min",
    "Max":"max",
    "Variable":"variable",
    "System Throughput Mass Flow":"systemThroughputMassFlow",
    "System Throughput Molar Flow":"systemThroughputMolarFlow"
};


export const PipeDimensionKeys = {
    "diameter":"crossSectionDimension1",
    "height":"crossSectionDimension1",
    "width":"crossSectionDimension2",
    "insideDiameter":"crossSectionDimension1",
    "radialGap":"crossSectionDimension2",
    "length":"length",
    "parallel":"parallel",
    "temperature":"temperature",
    "bends":"bends"
}


